import {
  LibraryDocumentInstructionEditRestartMode,
  LibraryDocumentInstructionEditRunStatus,
  LibraryDocumentInstructionEditStage,
} from 'models/copilot/libraryDocumentInstructionEditProcess';

// Backend DTOs for the library document instruction edit process endpoints. Dates are ISO strings and enums
// are numeric on the wire (default ASP.NET serialization), matching the model enums.

export class LibraryDocumentInstructionEditStatusDTO {
  exists?: boolean;

  externalId?: string;

  libraryLinkId?: number;

  libraryListId?: number;

  title?: string;

  status?: LibraryDocumentInstructionEditRunStatus;

  stage?: LibraryDocumentInstructionEditStage;

  runId?: string;

  attemptCount?: number;

  startedByUserId?: string;

  lastClaimedByUserId?: string;

  workerHeartbeat?: string;

  heartbeatStale?: boolean;

  started?: string;

  modified?: string;

  completed?: string;

  startedSharePointVersion?: string;

  startedSharePointModified?: string;

  savedSharePointVersion?: string;

  savedSharePointModified?: string;
}

export class LibraryDocumentInstructionEditStartRequestDTO {
  externalId?: string;

  restartMode?: LibraryDocumentInstructionEditRestartMode;

  startedSharePointVersion?: string;

  startedSharePointModified?: string;
}

export class LibraryDocumentInstructionEditStartResultDTO {
  started?: boolean;

  conflict?: boolean;

  status?: LibraryDocumentInstructionEditStatusDTO;

  runId?: string;

  libraryLinkId?: number;

  libraryListId?: number;

  driveItemId?: string;

  title?: string;

  pendingInstruction?: string;
}

export class LibraryDocumentInstructionEditClaimRequestDTO {
  libraryLinkId?: number;

  runId?: string;

  sessionId?: number;
}

export class LibraryDocumentInstructionEditRunRequestDTO {
  libraryLinkId?: number;

  runId?: string;
}

export class LibraryDocumentInstructionEditCompleteRequestDTO {
  libraryLinkId?: number;

  runId?: string;

  savedSharePointVersion?: string;

  savedSharePointModified?: string;
}

export class LibraryDocumentInstructionEditFailRequestDTO {
  libraryLinkId?: number;

  runId?: string;

  error?: string;
}

export class LibraryDocumentInstructionEditTransitionResultDTO {
  applied?: boolean;

  conflict?: boolean;

  status?: LibraryDocumentInstructionEditStatusDTO;
}
